module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0611d215fe34175ddbab01f4f48f3517.jpg";